import { render, staticRenderFns } from "./EPSFooter.vue?vue&type=template&id=ee036022&scoped=true&"
import script from "./EPSFooter.vue?vue&type=script&lang=js&"
export * from "./EPSFooter.vue?vue&type=script&lang=js&"
import style0 from "./EPSFooter.vue?vue&type=style&index=0&id=ee036022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee036022",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VFooter,VRow})
